var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Web3 = require('web3');

var tabookey = require('tabookey-gasless');

var ProxyProvider = require('./ProxyProvider');

var EventEmitter = require('./lib/EventEmitter');

var History = require('./History');

var HistoryEvent = require('./HistoryEvent');

var BurnerCore =
/*#__PURE__*/
function () {
  "use strict";

  function BurnerCore(_ref) {
    var _this = this;

    var _ref$signers = _ref.signers,
        signers = _ref$signers === void 0 ? [] : _ref$signers,
        _ref$gateways = _ref.gateways,
        gateways = _ref$gateways === void 0 ? [] : _ref$gateways,
        _ref$assets = _ref.assets,
        assets = _ref$assets === void 0 ? [] : _ref$assets,
        _ref$historyOptions = _ref.historyOptions,
        historyOptions = _ref$historyOptions === void 0 ? {} : _ref$historyOptions;

    _classCallCheck(this, BurnerCore);

    if (gateways.length === 0) {
      throw new Error('Must include at least 1 gateway');
    }

    this.providers = {};
    this.web3 = {};
    this.events = new EventEmitter();
    this.history = new History(_objectSpread({
      assets: assets
    }, historyOptions));
    this.gateways = gateways;
    this.assets = assets;
    this.assets.forEach(function (asset) {
      return asset.setCore(_this);
    });
    this.signers = signers;
    this.unsubscribesBySigner = {};
    this.signers.forEach(function (signer, index) {
      _this.unsubscribesBySigner[index] = _this.watchAccounts(signer.getAccounts());
      signer.onAccountChange(function () {
        _this.unsubscribesBySigner[index].forEach(function (unsubscribe) {
          return unsubscribe();
        });

        _this.unsubscribesBySigner[index] = _this.watchAccounts(signer.getAccounts());

        _this.events.emit('accountChange');
      });
    });
  }

  _createClass(BurnerCore, [{
    key: "watchAccounts",
    value: function watchAccounts(accounts) {
      var unsubscribes = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = accounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var account = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = this.assets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var asset = _step2.value;
              var unsubscribe = asset.startWatchingAddress(account);
              unsubscribes.push(unsubscribe);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return unsubscribes;
    }
  }, {
    key: "onAccountChange",
    value: function onAccountChange(callback) {
      var _this2 = this;

      this.events.on('accountChange', function () {
        return callback(_this2.getAccounts());
      });
    }
  }, {
    key: "getAssets",
    value: function getAssets() {
      return this.assets;
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      var availableSigners = this.signers.filter(function (signer) {
        return signer.isAvailable();
      });
      return [].concat.apply([], availableSigners.map(function (signer) {
        return signer.getAccounts();
      }));
    }
  }, {
    key: "signTx",
    value: function signTx(txParams) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.signers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var signer = _step3.value;

          if (signer.isAvailable() && signer.hasAccount(txParams.from)) {
            return signer.signTx(txParams);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      throw new Error('Unable to find an appropriate signer');
    }
  }, {
    key: "signMsg",
    value: function () {
      var _signMsg = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(msg, account) {
        var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, signer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context.prev = 3;
                _iterator4 = this.signers[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context.next = 12;
                  break;
                }

                signer = _step4.value;

                if (!(signer.isAvailable() && signer.hasAccount(account))) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", signer.signMsg(msg, account));

              case 9:
                _iteratorNormalCompletion4 = true;
                _context.next = 5;
                break;

              case 12:
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                _didIteratorError4 = true;
                _iteratorError4 = _context.t0;

              case 18:
                _context.prev = 18;
                _context.prev = 19;

                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }

              case 21:
                _context.prev = 21;

                if (!_didIteratorError4) {
                  _context.next = 24;
                  break;
                }

                throw _iteratorError4;

              case 24:
                return _context.finish(21);

              case 25:
                return _context.finish(18);

              case 26:
                throw new Error('Unable to find an appropriate signer');

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14, 18, 26], [19,, 21, 25]]);
      }));

      function signMsg(_x, _x2) {
        return _signMsg.apply(this, arguments);
      }

      return signMsg;
    }()
  }, {
    key: "shouldSkipSigning",
    value: function shouldSkipSigning(network, txParams) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.signers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var signer = _step5.value;

          if (signer.isAvailable() && signer.hasAccount(txParams.from)) {
            return signer.shouldSkipSigning();
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      throw new Error('Unable to find an appropriate signer');
    }
  }, {
    key: "handleRequest",
    value: function handleRequest(network, payload) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.gateways[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var gateway = _step6.value;

          if (gateway.isAvailable() && gateway.getNetworks().indexOf(network) !== -1) {
            return gateway.send(network, payload);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      throw new Error("Could not find gateway for network ".concat(network));
    }
  }, {
    key: "getProvider",
    value: function getProvider(network) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cacheKey = options.gasless ? "".concat(network, "-gasless") : network;

      if (this.providers[cacheKey]) {
        return this.providers[cacheKey];
      }

      var provider = new ProxyProvider(network, this);

      if (options.gasless) {
        provider = new tabookey.RelayProvider(provider, {
          txfee: 12,
          force_gasLimit: 5000000,
          force_gasPrice: 1100000000
        });
      }

      this.providers[cacheKey] = provider;
      return provider;
    }
  }, {
    key: "getWeb3",
    value: function getWeb3(network) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cacheKey = options.gasless ? "".concat(network, "-gasless") : network;

      if (this.web3[cacheKey]) {
        return this.web3[cacheKey];
      }

      this.web3[cacheKey] = new Web3(this.getProvider(network, options), null, {
        transactionConfirmationBlocks: 1
      });
      return this.web3[cacheKey];
    }
  }, {
    key: "canCallSigner",
    value: function canCallSigner(action, account) {
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.signers[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var signer = _step7.value;

          if (signer.isAvailable() && signer.hasAccount(account)) {
            return signer.permissions().indexOf(action) !== -1;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return false;
    }
  }, {
    key: "callSigner",
    value: function callSigner(action, account) {
      for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        params[_key - 2] = arguments[_key];
      }

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.signers[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var signer = _step8.value;

          if (signer.isAvailable() && signer.hasAccount(account)) {
            return signer.invoke.apply(signer, [action, account].concat(params));
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      throw new Error("Unable to find signer for ".concat(account));
    }
  }, {
    key: "addHistoryEvent",
    value: function addHistoryEvent(eventProps) {
      var event = new HistoryEvent(eventProps, this.assets);
      this.history.addEvent(event);
    }
  }, {
    key: "getHistoryEvents",
    value: function getHistoryEvents(options) {
      return this.history.getEvents(options);
    }
  }, {
    key: "onHistoryEvent",
    value: function onHistoryEvent(listener) {
      this.history.onEvent(listener);
    }
  }, {
    key: "removeHistoryEventListener",
    value: function removeHistoryEventListener(listener) {
      this.history.removeListener(listener);
    }
  }, {
    key: "stop",
    value: function stop() {
      Object.values(this.providers).forEach(function (provider) {
        return provider.stop();
      });
      Object.values(this.gateways).forEach(function (gateway) {
        return gateway.stop();
      });
      this.assets.forEach(function (asset) {
        return asset.stop && asset.stop();
      });
    }
  }]);

  return BurnerCore;
}();

module.exports = BurnerCore;